export const vsCompetitionData = {
    type: 'bar',
    data: {
	labels: ['Trinity', 'Leading Brand A', 'Leading Brand B'],
	datasets: [
	    { 
		label: 'Sheet Numbers Missed',
		data: [36,1614,172],
		backgroundColor: [
		    'rgba(71,183,132,.75)', // Green
		    'rgba(71,183,132,.75)', // Green
		    'rgba(71,183,132,.75)' // Green
		]
	    },
	    { 
		label: 'Sheet Titles Missed',
		data: [69,1840,2211],
		backgroundColor: [
		    'rgba(12,183,224,.75)', // Mid Blue
		    'rgba(12,183,224,.75)', // Mid Blue
		    'rgba(12,183,224,.75)' // Mid Blue
		]
	    },
	    { 
		label: 'Disciplines Missed',
		data: [47,1645,3277],
		backgroundColor: [
		    'rgba(255,0,0,.75)', // Red
		    'rgba(255,0,0,.75)', // Red
		    'rgba(255,0,0,.75)' // Red
		]
	    }
	]
    },
    options: {
	responsive: true,
	lineTension: 1,
	scales: {
	    yAxes: [{
		ticks: {
		    beginAtZero: true,
		    padding: 25,
		}
	    }]
	}
    }
}

export default vsCompetitionData;
